import {
  ActionType,
  AutoTextField,
  BooleanField,
  SelectAutocompleteField,
} from '../../../components/AutoForm/AutoFieldNew';
import {moneyFieldValueType} from '../../../components/AutoForm/AutoFormNew';
import {planFeesFieldType} from '../CreateRecommend/PlanFees';
import {recommendFieldsType} from '../CreateRecommend/recommendFields';
import {modelPortfolioField} from '../RecommendModify/modifyFieldTypes';

export type newSubplanFields = {
  planProvider?: string | null;
  singleClientAmount: moneyFieldValueType;
  recurringClientAmount?: moneyFieldValueType;
  singleEmployerAmount?: moneyFieldValueType;
  recurringEmployerAmount?: moneyFieldValueType;
  parentId?: string;
  existingPotId: string | null;
  checked: boolean;
  planFees?: planFeesFieldType;
  model?: modelPortfolioField;
  productProviderId?: string;
};

export type newPlanFields = {
  planFees: planFeesFieldType;
  existingPotId?: string;
  model?: modelPortfolioField;
  subplan0?: newSubplanFields;
  subplan1?: newSubplanFields;
  planProvider: string;
  planType: string;
  inTrust?: boolean;
  contactId: string;
  parentGuardianId?: string;
};

export type setUpNewFields = {
  newPlan?: newPlanFields;
};

export const setUpNewPlanProviderField: Omit<SelectAutocompleteField, 'id'> = {
  label: 'Select plan provider',
  type: ActionType.selectAutocomplete,
  options: [],
  initialValue: '',
};

export const setUpNewPlanTypeField: SelectAutocompleteField = {
  id: 'planType',
  label: 'Select product type',
  type: ActionType.selectAutocomplete,
  options: [],
  initialValue: '',
};

export const setUpNewPlanContactIdField: SelectAutocompleteField = {
  id: 'contactId',
  label: 'Plan contact',
  type: ActionType.selectAutocomplete,
  options: [],
  initialValue: '',
};

export const inTrustField: BooleanField<recommendFieldsType> = {
  id: 'inTrust' as any,
  label: 'In Trust',
  type: ActionType.boolean,
  yesValue: true,
  noValue: false,
  labelNotClickable: true,
};

export const investorCategoryField: AutoTextField<recommendFieldsType> = {
  id: 'investorCategory',
  label: 'Investor Category',
  type: ActionType.text,
  initialValue: '',
  readOnly: true,
};
